import moment from "moment";

class Utils{
    static changeStatus (status) {
        switch (status) {
            case "new":
                return "approved";
            case "approved":
                return "process";
            case "process":
                return "end";
            case "end":
                return "process";
            default:
                return status;
        }
    };
    static sumParentTimer(task) {
        if (!task?.child_tasks?.length) {
            return "0:00:00";
        }

        const sum = task.child_tasks.reduce((acc, childTask) => acc + Utils._timerSum(childTask.task_timer), 0);
        const duration = moment.duration(sum); // Already in milliseconds
        return `${Math.floor(duration.asHours())}${moment.utc(sum).format(":mm:ss")}`;
    }

    static _timerSum(taskTimer) {
        if (!Array.isArray(taskTimer)) return 0;

        return taskTimer.reduce((acc, timer) => {
            if (timer.start && timer.end) {
                const start = moment(timer.start);
                const end = moment(timer.end);
                return acc + end.diff(start); // Difference in milliseconds
            }
            return acc;
        }, 0);
    }
}

export default Utils;